import { Component, OnInit, input, inject, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import LayerGroup from 'ol/layer/Group';
import { FormsModule } from '@angular/forms';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { layerOpacity$, layerVisibility$ } from 'src/app/_helpers/rxjs_ol';
import { filter, switchMap, startWith, map } from 'rxjs';
import { AccordionComponent, AccordionItemComponent, SliderComponent, SwitchComponent } from '@aetherion/ui';


@Component({
  selector: 'app-layer-group',
  templateUrl: './layer-group.component.html',
  styleUrls: ['./layer-group.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatSliderModule,
    SliderComponent,
    SwitchComponent,
    FormsModule,
    AccordionComponent,
    AccordionItemComponent
  ]
})
export class LayerGroupComponent implements OnInit {
  readonly layerGroup = input<LayerGroup>(undefined);
  readonly layerType = input<'Base' | 'Normal' | 'Singular'>('Normal');

  readonly layers = computed(() => {
    const topLevelGroup = this.layerGroup();

    const layers = topLevelGroup
      .getLayersArray()
      .filter((lyr) => !(lyr instanceof LayerGroup));

    return layers;
  });

  readonly layerGroups = computed(() => {
    const topLevelGroup = this.layerGroup();

    const layerGroups = topLevelGroup
      .getLayersArray()
      .filter((lyr) => lyr instanceof LayerGroup);

    return layerGroups;
  });

  baseLayer$ = toObservable(this.layerGroup).pipe(
    filter((g): g is LayerGroup => g !== null)
  );

  opacity$ = this.baseLayer$.pipe(
    switchMap((g) => layerOpacity$(g))
  );

  visibility$ = this.baseLayer$.pipe(
    switchMap((g) => layerVisibility$(g))
  );

  // OL has opacity as a scale from 0 - 1, I.E 0.1 0.2 etc, we are mapping it to be easier to display percentages
  opacity = toSignal(this.opacity$.pipe(map(opacity => (opacity * 100))), {
    initialValue: 100
  });

  visible = toSignal(this.visibility$, {initialValue: true})

  opacityLabel = computed(() => {
    const opacity = this.opacity();

    return `${opacity}%`;
  });

  constructor()
  {

  }

  ngOnInit(): void {}

  setLayerGroupOpacity(value: number): void {
    this.layerGroup().setOpacity(Number(value.toFixed(0)) / 100);
  }

  setLayerGroupVisibility(visible: boolean): void {
    this.layerGroup().setVisible(visible);
  }

}
